import React from 'react'
import { withIcon } from '../../withIcon'

function MinusIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.375 12C4.375 11.6548 4.65482 11.375 5 11.375H19C19.3452 11.375 19.625 11.6548 19.625 12C19.625 12.3452 19.3452 12.625 19 12.625H5C4.65482 12.625 4.375 12.3452 4.375 12Z" fill={color}/>
    </svg>
  )
}

export default withIcon(MinusIcon)
